<template>
  <section>
    <h3 class="title text-center">{{ $t("solicitud.title") }}</h3>
    <stepper :steps="steps" :step="step"></stepper>
    <div class="card">
      <div class="card-header">{{ step + 1 }}. {{ steps[step].label }}</div>
      <div class="tabs">
        <form @submit.prevent="solicitar()" enctype="multipart/form-data">
          <!-- paso 1 -->
          <div class="card-body grid-form" :class="step == 0 ? 'active' : ''">
            <div class="alert alert-warning">
              <i class="icon-warning"></i> {{ $t("fields.info_email") }}
            </div>

            <!-- DATOS DEL TITULAR -->
            <div class="grid cols-3">
              <div class="form-group required">
                <label for="tipo-documento">{{ $t("fields.tipoDoc") }}</label>
                <select
                  class="form-control"
                  id="tipo-documento"
                  name="tipoDoc"
                  maxlength="20"
                  :disabled="true"
                  v-validate="'required'"
                  v-model="form.tipoDoc"
                >
                  <option
                    v-for="(value, key) in tipoDocs"
                    :value="key"
                    :key="`td${key}`"
                    >{{ value }}</option
                  >
                </select>
              </div>
              <div class="form-group required">
                <label for="nro-documento">{{ $t("fields.nroDoc") }}</label>
                <input
                  type="text"
                  class="form-control"
                  id="nro-documento"
                  name="nroDoc"
                  :disabled="true"
                  v-validate="'required'"
                  v-model="form.nroDoc"
                />
              </div>
              <div class="form-group required">
                <label for="nro-documento"
                  >{{ $t("fields.fecha_nacimiento") }} (dia/mes/año)</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="fecha_nacimiento"
                  name="fecha_nacimiento"
                  :disabled="true"
                  v-validate="'required'"
                  v-model="form.fecha_nacimiento"
                />
              </div>
            </div>

            <div v-if="observado">
              <div class="alert alert-danger">
                <i class="icon-warning"></i> <strong>{{ observado }}</strong>
              </div>
            </div>

            <div v-if="this.form.tipoDoc === 'CI'">
              <div class="grid cols-4">
                <div class="form-group required">
                  <label for="nombres">{{ $t("fields.nombres") }}</label>
                  <input
                    type="text"
                    id="nombres"
                    name="nombres"
                    class="form-control"
                    :disabled="true"
                    v-validate="'required'"
                    v-model="form.nombres"
                  />
                </div>
                <div class="form-group">
                  <label for="primer-ap">{{ $t("fields.primerAp") }}</label>
                  <input
                    type="text"
                    class="form-control"
                    id="primer-ap"
                    :disabled="true"
                    v-model="form.primerAp"
                  />
                </div>
                <div class="form-group">
                  <label for="segundo-ap">{{ $t("fields.segundoAp") }}</label>
                  <input
                    type="text"
                    class="form-control"
                    id="segundo-ap"
                    :disabled="true"
                    v-model="form.segundoAp"
                  />
                </div>
                <div class="form-group required">
                  <label for="nacionalidad">{{
                    $t("fields.nacionalidad")
                  }}</label>
                  <select
                    class="form-control"
                    id="nacionalidad"
                    name="nacionalidad"
                    v-validate="'required'"
                    :disabled="!!observado"
                    v-model="form.nacionalidad"
                  >
                    <option v-for="item in paises" :value="item.nacionalidad">{{
                      item.nacionalidad
                    }}</option>
                  </select>
                  <span
                    v-show="errors.has('nacionalidad')"
                    class="error-help"
                    >{{ errors.first("nacionalidad") }}</span
                  >
                </div>
              </div>
            </div>

            <div class="grid cols-2">
              <div class="form-group">
                <label for="telefono">{{ $t("fields.telefono") }}</label>
                <input
                  type="text"
                  class="form-control"
                  :disabled="true"
                  v-model="form.telefono"
                />
              </div>
              <!-- PARA CUANDO HAYA SMS -->
              <!-- <div class="form-group">
                  <label for="telefono">{{ $t('fields.telefono') }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.telefono">
                </div> -->
              <div class="form-group">
                <label for="email">{{ $t("fields.email") }}</label>
                <input
                  type="text"
                  placeholder="@"
                  class="form-control"
                  id="email"
                  :disabled="true"
                  name="email"
                  v-model="form.email"
                />
              </div>
              <!-- PARA CUANDO HAYA SMS -->
              <!-- <div class="form-group" :class="{ 'error-input': errors.has('email') }">
                  <label for="email">{{ $t('fields.email') }}</label>
                  <input
                    type="text"
                    placeholder="@"
                    class="form-control"
                    id="email"
                    name="email"
                    v-validate="'email'"
                    v-model="form.email">
                    <span v-show="errors.has('email')" class="error-help">{{ errors.first('email') }}</span>
                </div> -->
            </div>

            <div class="btn-container">
              <button
                class="btn"
                type="button"
                @click="cleanFormTitular()"
                v-if="observado"
              >
                Cambiar de titular
              </button>
              <button class="btn" type="button" @click="cancel()">
                {{ $t("btn.cancel") }} <i class="icon-cancel-circle"></i>
              </button>
              <button
                class="btn btn-primary"
                type="button"
                @click="contrastarPersona"
                :disabled="btnNext || observado"
              >
                {{ btnNext ? $t("btn.register") : $t("btn.next") }}
                <i class="icon-arrow-right2"></i>
              </button>
            </div>
          </div>
          <!-- ===== -->

          <!-- paso 2 -->
          <div class="card-body grid-form" :class="step == 1 ? 'active' : ''">
            <div class="grid cols-3">
              <div class="form-group">
                <label for="">{{ $t("fields.tipoDoc") }}</label>
                <p class="form-control">
                  {{ tipoDocs[form.tipoDoc] }}
                  {{ form.tipo ? " - " + form.tipo : "" }}
                </p>
              </div>
              <div class="form-group">
                <label for="">{{ $t("fields.nroDoc") }}</label>
                <p class="form-control">{{ form.nroDoc }}</p>
              </div>
              <div class="form-group">
                <label for="">{{ $t("fields.fecha_nacimiento") }}</label>
                <p class="form-control">
                  {{ form.fecha_nacimiento }}
                </p>
              </div>
            </div>
            <div class="grid cols-2-1">
              <div class="form-group">
                <label for="">{{ $t("fields.nombre_solicitante") }}</label>
                <p class="form-control">
                  {{ form.nombres }} {{ form.primerAp }} {{ form.segundoAp }}
                </p>
              </div>
              <div class="form-group">
                <label for="">{{ $t("fields.nacionalidad") }}</label>
                <p class="form-control">{{ form.nacionalidad }}</p>
              </div>
            </div>
            <div class="alert alert-info">
              <i class="icon-info"></i> {{ $t("fields.info_agregar") }}
            </div>
            <div class="grid add-document">
              <div class="form-group required">
                <label for="">{{ $t("fields.desc_doc") }}</label>
                <!-- select class="form-control" v-model="form.id_documento">
                  <option value="">{{ $t("fields.select_doc") }}</option>
                  <optgroup
                    v-for="(items, key) in documentos"
                    :label="key"
                    :key="`k${key}`"
                  >
                    <option
                      :value="item.id"
                      v-for="item in items"
                      :key="`d${item.id}`"
                      >{{ item.nombre }}</option
                    >
                  </optgroup>
                </select -->
               <v-select :options="docs" label="nombre" :clearable="false" v-model="form.id_documento"></v-select>
              </div>
              <div class="form-group required">
                <label for="">{{ $t("fields.precio") }}</label>
                <input
                  type="text"
                  class="form-control text-right"
                  disabled
                  v-model="precio"
                  placeholder="0"
                />
              </div>
              <div class="form-group">
                <label>&nbsp;</label>
                <button
                  class="btn btn-success"
                  title="Agregar documento"
                  type="button"
                  @click="add()"
                >
                  <i class="icon-plus"></i> {{ $t("fields.agregar") }}
                </button>
              </div>
            </div>

            <div class="documentos">
              <h4 class="title">
                {{ $t("fields.mis_doc") }}
                {{
                  docsSolicitud.length
                    ? ` - Total: ${docsSolicitud.length}`
                    : ""
                }}
              </h4>
              <div
                class="alert alert-warning"
                v-if="docsSolicitud.length === 0"
              >
                <i class="icon-warning"></i> {{ $t("fields.alert_doc") }}
              </div>
              <div v-if="docsSolicitud.length" class="documentos">
                <div
                  class="documento"
                  v-for="(item, index) in docsSolicitud"
                  :key="`d${index}`"
                >
                  <h5 class="title">{{ index + 1 }}. {{ item.nombre }}</h5>
                  <p class="description">{{ item.descripcion }}</p>
                  <p>
                    <small
                      ><strong
                        >Vigencia del documento legalizado/certificado: </strong
                      >{{ item.vigencia }} meses</small
                    >
                  </p>
                  <br />
                  <div class="grid cols-2 campos-extra">
                    <div
                      class="md-radio-container"
                      v-if="servicioApostilla === 'ACTIVADO' && item.apostillar"
                    >
                      para
                      <div class="tooltip">
                        APOSTILLAR
                        <span class="tooltiptext"
                          >La Apostilla es una certificación emitida por la
                          Cancillería Boliviana que permite reconocer los
                          documentos públicos bolivianos en los países miembro
                          del convenio de La Haya sobre la Apostilla.</span
                        >
                      </div>
                      <div class="md-radio md-radio-inline">
                        <input
                          :id="'apostillar-no' + index"
                          type="radio"
                          v-model="item.para_apostillar"
                          :name="'radio' + index"
                          value="false"
                          checked
                          :disabled="!form.email || form.email === ''"
                        />
                        <label :for="'apostillar-no' + index">NO</label>
                      </div>
                      <div class="md-radio md-radio-inline">
                        <input
                          :id="'apostillar-si' + index"
                          type="radio"
                          v-model="item.para_apostillar"
                          :name="'radio' + index"
                          value="true"
                          :disabled="!form.email || form.email === ''"
                        />
                        <label :for="'apostillar-si' + index">SÍ</label>
                      </div>
                      <br />
                      <span v-if="!form.email"
                        ><small
                          ><strong>Nota.-</strong> Usted no puede cambiar la
                          opción apostillar si no ha introducido una dirección
                          de correo electrónico de contacto.</small
                        ></span
                      >
                    </div>
                    <div
                      class="form-group required"
                      :class="{ 'error-input': errors.has('gestion' + index) }"
                      v-if="item.clasificacion !== 'EMITIDO_TERCEROS'"
                    >
                      <label :for="'gestion' + index"
                        >{{ $t("fields.select_gestion") }} a LEGALIZAR
                      </label>
                      <select
                        class="form-control"
                        v-model="item.gestion"
                        v-validate="'required'"
                        :name="'gestion' + index"
                      >
                        <option
                          :value="i"
                          v-for="i in gestiones"
                          :key="`g${i}`"
                          >{{ i }}</option
                        >
                      </select>
                      <span v-show="errors.has('gestion')" class="error-help">{{
                        errors.first("gestion" + index)
                      }}</span>
                    </div>
                  </div>

                  <div class="grid cols-2 campos-extra">
                    <div
                      class="form-group required"
                      :class="{
                        'error-input': errors.has('tipoSolicitud' + index)
                      }"
                    >
                      <label :for="'tipoSolicitud' + index">{{
                        $t("fields.tipoSolicitud")
                      }}</label>
                      <input
                        type="text"
                        class="form-control"
                        :name="'tipoSolicitud' + index"
                        maxlength="20"
                        v-validate="'required'"
                        v-model="item.tipoSolicitud"
                        disabled
                      />
                      <span
                        v-show="errors.has('tipoSolicitud')"
                        class="error-help"
                        >{{ errors.first("tipoSolicitud" + index) }}</span
                      >
                    </div>
                    <div
                      class="form-group required"
                      :class="{ 'error-input': errors.has('motivo' + index) }"
                    >
                      <label :for="'motivo' + index">{{
                        $t("fields.motivo")
                      }}</label>
                      <select
                        class="form-control"
                        v-model="item.motivo"
                        v-validate="'required'"
                        :name="'motivo' + index"
                      >
                        <option
                          :value="i.nombre"
                          v-for="i in motivos"
                          :key="`mot${i.id}`"
                          >{{ i.nombre }}</option
                        >
                      </select>
                      <span v-show="errors.has('motivo')" class="error-help">{{
                        errors.first("motivo" + index)
                      }}</span>
                      <div
                        class="form-group required"
                        :class="{
                          'error-input': errors.has('otroMotivo' + index)
                        }"
                        v-if="item.motivo === 'Otro'"
                      >
                        <label :for="'otroMotivo' + index">{{
                          $t("fields.especifique_motivo_otro")
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          :name="'otroMotivo' + index"
                          v-validate="'required'"
                          v-model="item.otroMotivo"
                          maxlength="200"
                          @input="item.otroMotivo = $event.target.value.toUpperCase()"
                        />
                        <span
                          v-show="errors.has('motivoOtro')"
                          class="error-help"
                          >{{ errors.first("motivoOtro" + index) }}</span
                        >
                      </div>
                      <div
                        class="form-group required"
                        :class="{
                          'error-input': errors.has('otroMotivo' + index)
                        }"
                        v-if="item.motivo === 'Presentación para Fuente Laboral'"
                      >
                        <label :for="'otroMotivo' + index">{{
                          $t("fields.especifique_motivo_laboral")
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          :name="'otroMotivo' + index"
                          v-validate="'required'"
                          v-model="item.otroMotivo"
                          maxlength="200"
                          @input="item.otroMotivo = $event.target.value.toUpperCase()"
                        />
                        <span
                          v-show="errors.has('motivoOtro')"
                          class="error-help"
                          >{{ errors.first("motivoOtro" + index) }}</span
                        >
                      </div>
                      <div
                        class="form-group required"
                        :class="{
                          'error-input': errors.has('otroMotivo' + index)
                        }"
                        v-if="item.motivo === 'Trámites de Postgrado'"
                      >
                        <label :for="'otroMotivo' + index">{{
                          $t("fields.especifique_motivo_universidades")
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          :name="'otroMotivo' + index"
                          v-validate="'required'"
                          v-model="item.otroMotivo"
                          maxlength="200"
                          @input="item.otroMotivo = $event.target.value.toUpperCase()"
                        />
                        <span
                          v-show="errors.has('motivoOtro')"
                          class="error-help"
                          >{{ errors.first("motivoOtro" + index) }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <p class="entidad">
                    <small
                      ><strong v-if="item.entidad_sigla"
                        >{{ item.entidad_sigla }} - </strong
                      >{{ item.entidad_nombre }}
                    </small>
                  </p>

                  <div class="opciones">
                    <button
                      class="btn btn-danger btn-small"
                      type="button"
                      title="Eliminar"
                      @click="remove(index)"
                    >
                      <i class="icon-bin"></i> {{ $t("fields.eliminar") }}
                    </button>
                    <div class="precio">
                      {{ $t("fields.costo") }}:
                      <strong>{{ item.precio }}</strong> Bs.
                    </div>
                  </div>
                </div>
                <div class="total">
                  <p>
                    {{ $t("fields.costo_total")
                    }}<strong>{{ totalLegalizacion || 0 }}</strong>
                    <small>Bs.</small>
                  </p>
                </div>
              </div>
            </div>
            <div v-if="docsSolicitud.length" class="documentos">
              <div class="alert alert-info">
                <i class="icon-info"></i> {{ $t("fields.select_departamento") }}
              </div>
              <div
                class="form-group required"
                :class="{ 'error-input': errors.has('regional') }"
              >
                <label for="regional">{{ $t("fields.regional") }}</label>
                <select
                  class="form-control"
                  id="regional"
                  name="regional"
                  v-model="form.regional"
                  v-validate="'required'"
                >
                  <option
                    v-for="item in regionales"
                    :value="item"
                    :key="`r${item}`"
                    >{{ item }}</option
                  >
                </select>
                <span v-show="errors.has('regional')" class="error-help">{{
                  errors.first("regional")
                }}</span>
              </div>
            </div>
    <!--         <h5 class="title title-titular">
              <span>{{ $t("fields.confirmacion_apoderado") }}</span>
              <div class="md-radio-container">
                <div class="md-radio md-radio-inline">
                  <input
                    id="titular-si"
                    type="radio"
                    v-model="form.titular"
                    name="titular"
                    value="TITULAR"
                    checked
                  />
                  <label for="titular-si">{{ $t("fields.soy_titular") }}</label>
                </div>
                <div class="md-radio md-radio-inline">
                  <input
                    id="titular-no"
                    type="radio"
                    v-model="form.titular"
                    name="titular"
                    value="TRAMITADOR"
                  />
                  <label for="titular-no">{{
                    $t("fields.soy_apoderado")
                  }}</label>
                </div>
              </div>
            </h5> -->

            <!-- DATOS DEL TRAMITADOR -->
            <div v-if="form.titular == 'TRAMITADOR'">
              <div class="grid cols-2">
                <div class="alert alert-info">
                  <i class="icon-info"></i>
                  <span class="cuadro-texto-apoderado"
                    >Ingrese los datos del apoderado y valide que estos se
                    encuentren registrados en el SEGIP o Migración.</span
                  >
                </div>
                <div class="alert alert-info">
                  <i class="icon-info"></i>
                  <span class="cuadro-texto-apoderado"
                    ><strong>Datos del apoderado.-</strong> Es la persona que va
                    a realizar el trámite de la legalización/certificación en
                    representación del titular del documento.</span
                  >
                </div>
              </div>
              <div v-if="tramitadorObservado">
                <div class="alert alert-danger">
                  <i class="icon-danger"></i>
                  <strong>{{ tramitadorObservado }}</strong>
                </div>
              </div>
              <div class="grid cols-3-1">
                <div
                  class="form-group required"
                  :class="{ 'error-input': errors.has('tramitador_tipoDoc') }"
                >
                  <label for="tramitador-tipo-documento">{{
                    $t("fields.tipoDoc")
                  }}</label>
                  <select
                    class="form-control"
                    id="tramitador-tipo-documento"
                    name="tramitador_tipoDoc"
                    :disabled="validado"
                    v-validate="'required'"
                    v-model="form.tramitador_tipoDoc"
                  >
                    <option
                      v-for="(value, key) in tipoDocs"
                      :value="key"
                      :key="`tD${key}`"
                      >{{ value }}</option
                    >
                  </select>
                  <span
                    v-show="errors.has('tramitador_tipoDoc')"
                    class="error-help"
                    >{{ errors.first("tramitador_tipoDoc") }}</span
                  >
                </div>
                <div
                  class="form-group required"
                  :class="{ 'error-input': errors.has('tramitador_nroDoc') }"
                >
                  <label for="tramitador-nro-documento">{{
                    $t("fields.nroDoc")
                  }}</label>
                  <input
                    type="text"
                    class="form-control"
                    id="tramitador-nro-documento"
                    name="tramitador_nroDoc"
                    :disabled="validado"
                    v-validate="'required'"
                    maxlength="20"
                    v-model="form.tramitador_nroDoc"
                  />
                  <span
                    v-show="errors.has('tramitador_nroDoc')"
                    class="error-help"
                    >{{ errors.first("tramitador_nroDoc") }}</span
                  >
                </div>
                <date-select
                  :required="true"
                  :disabled="validado"
                  :label="$t('fields.fecha_nacimiento')"
                  v-if="tramitadorDateShow"
                  model="solicitud.tramitador_fecNacimiento"
                ></date-select>
                <div>
                  <div>
                    <span v-if="validado && !tramitadorObservado"
                      ><i class="icon-checkmark"></i> VALIDADO</span
                    >
                  </div>
                  <button
                    class="btn btn-search"
                    type="button"
                    @click="cambiar"
                    v-if="validado"
                  >
                    Cambiar
                  </button>
                  <button
                    class="btn btn-success btn-search"
                    type="button"
                    @click="validar"
                    :disabled="btnValidar"
                    v-else
                  >
                    <i class="icon-search"></i>
                    {{ btnValidar ? "Validando" : "Validar" }}
                  </button>
                </div>
              </div>

              <div
                v-show="
                  error.tramitador_apellidos && form.tramitador_tipoDoc === 'CI'
                "
                class="alert alert-danger"
              >
                Debe llenar su nombre completo, incluyendo
                <strong>apellidos</strong>. Por favor, no tome en cuenta
                apellidos de casada.
              </div>
              <div
                class="grid cols-3-1"
                v-if="form.tramitador_tipoDoc === 'CI'"
              >
                <div
                  class="form-group required"
                  :class="{ 'error-input': errors.has('tramitador_nombres') }"
                >
                  <label for="tramitador_nombres">{{
                    $t("fields.nombres")
                  }}</label>
                  <input
                    type="text"
                    id="tramitador_nombres"
                    name="tramitador_nombres"
                    class="form-control"
                    :disabled="validado"
                    v-validate="'required'"
                    @input="
                      form.tramitador_nombres = $event.target.value.toUpperCase()
                    "
                    v-model="form.tramitador_nombres"
                  />
                  <span
                    v-show="errors.has('tramitador_nombres')"
                    class="error-help"
                    >{{ errors.first("tramitador_nombres") }}</span
                  >
                </div>
                <div class="form-group">
                  <label for="primer-ap">{{ $t("fields.primerAp") }}</label>
                  <input
                    type="text"
                    class="form-control"
                    :disabled="validado"
                    id="tramitador-primer-ap"
                    @input="
                      form.tramitador_primerAp = $event.target.value.toUpperCase()
                    "
                    v-model="form.tramitador_primerAp"
                  />
                </div>
                <div class="form-group">
                  <label for="segundo-ap">{{ $t("fields.segundoAp") }}</label>
                  <input
                    type="text"
                    class="form-control"
                    :disabled="validado"
                    id="tramitador-segundo-ap"
                    @input="
                      form.tramitador_segundoAp = $event.target.value.toUpperCase()
                    "
                    v-model="form.tramitador_segundoAp"
                  />
                </div>
                <div
                  class="form-group required"
                  :class="{
                    'error-input': errors.has('tramitador_nacionalidad')
                  }"
                >
                  <label for="tramitador_nacionalidad">{{
                    $t("fields.nacionalidad")
                  }}</label>
                  <select
                    class="form-control"
                    id="tramitador_nacionalidad"
                    name="tramitador_nacionalidad"
                    v-validate="'required'"
                    :disabled="validado"
                    v-model="form.tramitador_nacionalidad"
                  >
                    <option v-for="item in paises" :value="item.nacionalidad">{{
                      item.nacionalidad
                    }}</option>
                  </select>
                  <span
                    v-show="errors.has('tramitador_nacionalidad')"
                    class="error-help"
                    >{{ errors.first("tramitador_nacionalidad") }}</span
                  >
                </div>
              </div>
            </div>
            <!-- DATOS DEL TRAMITADOR FIN -->
            <div class="btn-container btn-margin">
              <button class="btn" type="button" @click="cancel">
                {{ $t("btn.cancel") }} <i class="icon-blocked"></i>
              </button>
              <!-- <button class="btn" type="button" @click="prev">{{ $t('btn.prev') }} <i class="icon-arrow-left2"></i></button> -->
              <button
                class="btn btn-primary"
                type="submit"
                :disabled="btnSolicitar"
              >
                {{ btnSolicitar ? $t("btn.solicitando") : $t("btn.solicitar") }}
                <i class="icon-checkmark"></i>
              </button>
            </div>
          </div>
          <!-- ===== -->
        </form>

        <!-- paso 3 -->
        <div class="card-body" :class="step == 2 ? 'active' : ''">
          <!-- <div class="alert alert-info">
              <i class="icon-info"></i> {{$t('fields.cod_seguimiento')}} {{ codigo }}
            </div> -->
          <div class="alert alert-info">
            <i class="icon-info"></i> <strong>{{ $t("fields.nota") }}</strong>
            {{ $t("fields.nota_contenido") }}.
          </div>
          <!-- div class="alert alert-danger">
            <i class="icon-notification"></i> <strong>IMPORTANTE:</strong>
            {{ $t("fields.nota_contenido_2") }}
          </div -->
          <div class="alert alert-warning">
            <i class="icon-warning"></i> <strong>Nota:</strong> Los adjuntos no
            deben pesar más de <strong>{{ maxFileSize }} mb</strong>, el formato
            debe ser PDF.
          </div>
          <div v-if="arrayTerceros.length" class="documentos">
            <div
              class="documento"
              v-for="(item, index) in arrayTerceros"
              :key="`tercero${index}`"
            >
              <h5 class="title">
                {{ index + 1 }}. {{ item["documento.nombre"] }}
              </h5>
              <p class="description">{{ item["documento.descripcion"] }}</p>
              <br />
              <span> {{ item.paraApostillar ? "para APOSTILLAR" : "" }}</span>
              <span>
                {{
                  item.tipo_solicitud === "CERTIFICACION" ? "CERTIFICACIÓN" : ""
                }}</span
              >
              <!-- TODO: agregar los campos para que es el documento -->
              <div class="grid cols-2 campos-extra">
                <div
                  class="form-group required"
                  :class="{ 'error-input': errors.has(`archivo-${index}`) }"
                >
                  <label :for="'archivo-' + index">{{
                    $t("fields.adjunto")
                  }}</label>
                  <adjunta-archivo
                    :model="'archivo-' + index"
                    :idTramiteDoc="item.id + ''"
                    :maxSize="maxFileSize"
                  ></adjunta-archivo>
                  <span
                    v-show="errors.has(`archivo-${index}`)"
                    class="error-help"
                    >{{ errors.first(`archivo-${index}`) }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="btn-container">
            <button class="btn btn-primary" type="button" @click="continuar()">
              {{ $t("btn.next") }} <i class="icon-checkmark2"></i>
            </button>
          </div>
        </div>
        <!-- ===== -->

        <!-- paso 4 -->
        <div class="card-body" :class="step == 3 ? 'active' : ''">
          <div class="alert alert-success">
            <i class="icon-checkmark"></i> {{ $t("fields.fin_solicitud") }}
          </div>
          <div class="text-center">
            <p class="finalizado">
              {{ $t("fields.cod_seguimiento") }}
              <span class="codigo-text">{{ codigo }}</span>
            </p>
          </div>
          <div class="alert alert-info">
            <i class="icon-info"></i>
            <strong>{{ $t("fields.guardar_codigo") }}</strong
            >{{ $t("fields.seguimiento_codigo")
            }}<strong
              ><router-link to="/seguimiento">{{
                $t("fields.aqui")
              }}</router-link></strong
            >.
          </div>
          <div class="alert alert-warning" v-if="medio_notificacion">
            <i class="icon-warning"></i> <strong>Nota: </strong>Si usted no ha
            ingresado un correo electrónico para enviarle notificaciones, el
            código de seguimiento será su único medio para consultar el estado
            de su solicitud.
          </div>
          <div class="btn-container">
            <button class="btn btn-primary" type="button" @click="finish()">
              {{ $t("btn.finalizar") }} <i class="icon-checkmark2"></i>
            </button>
          </div>
        </div>
        <!-- ===== -->
      </div>
    </div>
  </section>
</template>

<script>
import Stepper from "@/components/util/Stepper";
import DateSelect from "@/components/util/DateSelect";
import Location from "@/components/util/Location";
import documentos from "@/components/pages/mixins/documentos";
import paises from "@/components/pages/mixins/paises";
import AdjuntaArchivo from "@/components/util/AdjuntaArchivo";

import delay from "delay";

const tipoDocs = {
  CI: "CÉDULA DE IDENTIDAD",
  PASAPORTE: "PASAPORTE"
};

const tipoSolicitudes = {
  LEGALIZACION: "LEGALIZACIÓN",
  CERTIFICACION: "CERTIFICACIÓN",
  APOSTILLA: "APOSTILLA"
};

const regionales = [
  "BENI",
  "CHUQUISACA",
  "COCHABAMBA",
  "LA PAZ",
  "ORURO",
  "PANDO",
  "POTOSI",
  "SANTA CRUZ",
  "TARIJA"
];

export default {
  mixins: [documentos, paises],
  mounted () {
    this.getDocumentos(true);

    // this.getCostoLegalizacion();

    this.paises = this.getPaises();
    this.generaGestiones(1986);
    this.$service.get("parametricas?grupo=MOTIVO").then(response => {
      if (response && response.data && response.data.rows.length > 0) {
        this.motivos = response.data.rows
          .map(elemento => {
            return {
              id: elemento.id,
              nombre: elemento.nombre,
              estado: elemento.estado
            };
          })
          .filter(elemento => elemento.estado === "ACTIVO");
      }
    });

    this.$service.get("parametros/MAX_FILESIZE").then(response => {
      if (response && response.data) {
        this.maxFileSize = parseInt(response.data.valor);
      }
    });

    this.$service
      .get("parametros/ACTIVAR_SERVICIO_APOSTILLA")
      .then(response => {
        if (response && response.data) {
          this.servicioApostilla = response.data.valor;
        }
      });

    this.$serviceoidc.getProfile().then(response => {
      if (response) {
        this.form.telefono = response.celular;
        this.form.email = response.email;

        this.form.nombres = response.profile.nombre.nombres;
        this.form.primerAp = response.profile.nombre.primer_apellido;
        this.form.segundoAp = response.profile.nombre.segundo_apellido;

        this.form.nroDoc =
          response.profile.documento_identidad.numero_documento;
        this.form.fecha_nacimiento = response.fecha_nacimiento;
      }
    });
  },
  data () {
    return {
      steps: [
        { label: this.$t("fields.info_sol") },
        { label: this.$t("fields.info_doc") },
        { label: this.$t("fields.info_doc_adjuntar") },
        { label: this.$t("fields.info_finalizado") }
      ],
      step: 0,
      servicioApostilla: "DESACTIVADO",
      medio_notificacion: false,
      dateShow: true,
      tramitadorDateShow: true,
      regionales,
      documentos: [],
      paises: [],
      observado: false,
      tramitadorObservado: false,
      form: {
        tipoDoc: "CI",
        nroDoc: "",
        fecha_nacimiento: new Date(),
        nombres: "",
        primerAp: "",
        segundoAp: "",
        telefono: "",
        email: "",
        tipo: null,
        regional: null,
        nacionalidad: "BOLIVIANA",
        id_documento: "",
        titular: "TITULAR",
        tramitador_tipoDoc: "CI",
        tramitador_nroDoc: "",
        tramitador_nombres: "",
        tramitador_primerAp: "",
        tramitador_segundoAp: "",
        tramitador_nacionalidad: "BOLIVIANA"
      },
      precio: "",
      monto: "",
      error: {
        contacto: false,
        apellidos: false,
        tramitador_apellidos: false
      },
      docsSolicitud: [],
      codigo: "",
      btnNext: false,
      btnValidar: false,
      btnSolicitar: false,
      titular: "SI",
      costoLegalizacion: 0,
      validado: false,
      tipoDocs,
      tipoSolicitudes,
      clasificacion: "",
      arrayTerceros: [],
      gestiones: [],
      motivos: [],
      maxFileSize: 0
    };
  },
  methods: {
    getNacionalidad (pais) {
      for (let i in this.paises) {
        if (this.paises[i].pais === pais) {
          return this.paises[i].nacionalidad;
        }
      }
      return pais;
    },

    async contrastarPersona () {
      this.$store.commit("setValid", true);
      // // this.error.contacto = this.$filter.empty(this.form.telefono) && this.$filter.empty(this.form.email);

      // if (this.form.tipoDoc === "CI") {
      //   this.error.apellidos =
      //     this.$filter.empty(this.form.primerAp) &&
      //     this.$filter.empty(this.form.segundoAp);
      // }

      // if (
      //   (await this.$validator.validateAll()) &&
      //   !this.$filter.empty(this.$store.state.solicitud.fecNacimiento) &&
      //   !this.error.contacto &&
      //   !this.btnNext &&
      //   !this.error.apellidos
      // ) {
      //   let doc = this.getNroDocumento(this.form.nroDoc);
      //   let dataContrastacion = {
      //     tipoDoc: this.form.tipoDoc,
      //     nroDoc: doc.nroDocumento,
      //     fecNacimiento: this.$util.formatDate(
      //       this.$store.state.solicitud.fecNacimiento
      //     ),
      //     complemento: doc.complemento,
      //     nombres: this.form.nombres,
      //     primer_apellido: this.form.primerAp,
      //     segundo_apellido: this.form.segundoAp,
      //     nacionalidad: this.form.nacionalidad
      //   };
      let data = {};
      //   if (!this.observado) {
      //     this.btnNext = true;
      //     this.$service
      //       .post("registrar-datos-contrastacion", dataContrastacion)
      //       .then(response => {
      //         this.btnNext = false;
      //         if (response) {
      //           if (response.code !== 1) {
      //             if (response.code === -1) {
      //               this.observado =
      //                 "Los datos no son correctos. Por favor, verifique sus datos.";
      //               this.$message.warning(response.message);
      //             } else {
      //               if (response.code === 2) {
      //                 this.observado = "Los datos introducidos no existen.";
      //                 this.$message.warning(response.message);
      //               } else {
      //                 this.observado =
      //                   "Tiene observaciones en el SEGIP, debe solucionarlas para poder continuar";
      //                 this.$message.warning(response.message);
      //               }
      //             }
      //           } else {
      //             if (response.code === 1) {
      //               this.step = 1;
      //               data.fecNacimiento = this.$store.state.solicitud.fecNacimiento;
      //               data.email = this.form.email;
      //               data.telefono = this.form.telefono;
      //               data.nombres = this.form.nombres;
      //               data.primerAp = this.form.primerAp;
      //               data.segundoAp = this.form.segundoAp;
      //               data.nacionalidad = this.form.nacionalidad;
      //               data.tipoDoc = this.form.tipoDoc;
      //               data.nroDoc = doc.nroDocumento;
      //               this.$store.commit("setSolicitud", data);
      //             }
      //           }
      //         }
      //       });
      //   } else {
      this.step = 1;
      this.form.tipo = null;
      data.fecNacimiento = this.form.fecha_nacimiento;
      data.email = this.form.email;
      data.telefono = this.form.telefono;
      data.nombres = this.form.nombres;
      data.primerAp = this.form.primerAp;
      data.segundoAp = this.form.segundoAp;
      data.nacionalidad = this.form.nacionalidad;
      data.tipoDoc = this.form.tipoDoc;
      data.nroDoc = this.form.nroDoc;

      console.log(this.form.tipoDoc);
      console.log(this.form.nroDoc);
      // if (
      //   typeof this.observado === "string" &&
      //   !this.$filter.empty(this.observado)
      // ) {
      //   data.observacion = this.observado;
      // }
      this.$store.commit("setSolicitud", data);
      // }
      // }
    },

    async buscarPersona () {
      this.$store.commit("setValid", true);
      // this.error.contacto = this.$filter.empty(this.form.telefono) && this.$filter.empty(this.form.email);
      if (
        (await this.$validator.validateAll()) &&
        !this.$filter.empty(this.$store.state.solicitud.fecNacimiento) &&
        !this.error.contacto &&
        !this.btnNext
      ) {
        let doc = this.getNroDocumento(this.form.nroDoc);
        let data = {
          tipoDoc: this.form.tipoDoc,
          nroDoc: doc.nroDocumento,
          fecNacimiento: this.$util.formatDate(
            this.$store.state.solicitud.fecNacimiento
          ),
          complemento: doc.complemento
        };
        if (!this.observado) {
          this.btnNext = true;
          this.$service.post("registrar-datos", data).then(response => {
            this.btnNext = false;
            if (response) {
              if (response.observacion) {
                this.observado = response.observacion;
              } else {
                this.observado = false;
                this.form.nombres = response.nombres;
                this.form.primerAp = response.paterno;
                this.form.segundoAp = response.materno;
                this.form.nacionalidad =
                  this.form.tipoDoc === "CI"
                    ? this.getNacionalidad(response.nacionalidad)
                    : response.nacionalidad;
                this.form.tipo = response.tipo;
                this.step = 1;

                data.fecNacimiento = this.$store.state.solicitud.fecNacimiento;
                data.email = this.form.email;
                data.telefono = this.form.telefono;
                data.nombres = this.form.nombres;
                data.primerAp = this.form.primerAp;
                data.segundoAp = this.form.segundoAp;
                data.nacionalidad = this.form.nacionalidad;

                this.$store.commit("setSolicitud", data);
              }
            }
          });
        } else {
          this.step = 1;
          this.form.tipo = null;
          data.fecNacimiento = this.$store.state.solicitud.fecNacimiento;
          data.email = this.form.email;
          data.telefono = this.form.telefono;
          data.nombres = this.form.nombres;
          data.primerAp = this.form.primerAp;
          data.segundoAp = this.form.segundoAp;
          data.nacionalidad = this.form.nacionalidad;
          if (
            typeof this.observado === "string" &&
            !this.$filter.empty(this.observado)
          ) {
            data.observacion = this.observado;
          }
          this.$store.commit("setSolicitud", data);
        }
      }
    },

    async validar () {
      this.error.tramitador_apellidos =
        this.$filter.empty(this.form.tramitador_primerAp) &&
        this.$filter.empty(this.form.tramitador_segundoAp) &&
        this.$filter.empty(this.form.tramitador_nombres);
      this.$store.commit("setValid", true); // TODO: Esto valida la fecha de nacimiento del titular del documento y no del tramitador
      if (
        (await this.$validator.validate("tramitador_nroDoc")) &&
        !this.btnValidar &&
        !this.error.tramitador_apellidos
      ) {
        let fechaNac = this.$store.state.solicitud.tramitador_fecNacimiento;
        if (this.$filter.empty(fechaNac)) {
          this.$message.warning("Ingrese la fecha de nacimiento del apoderado");
          return false;
        }
        if (this.$filter.empty(this.form.tramitador_nacionalidad)) {
          this.$message.warning("Debe ingresar la nacionalidad del apoderado");
          return false;
        }
        let doc = this.getNroDocumento(this.form.tramitador_nroDoc);
        let dataContraste = {
          tipoDoc: this.form.tramitador_tipoDoc,
          nroDoc: doc.nroDocumento,
          fecNacimiento: this.$util.formatDate(fechaNac),
          complemento: doc.complemento,
          nombres: this.form.tramitador_nombres,
          primer_apellido: this.form.tramitador_primerAp,
          segundo_apellido: this.form.tramitador_segundoAp,
          nacionalidad: this.form.tramitador_nacionalidad
        };
        this.btnValidar = true;
        this.$service
          .post("registrar-datos-contrastacion", dataContraste)
          .then(response => {
            this.btnValidar = false;
            if (response) {
              this.validado = true;
              if (response.code !== 1) {
                if (response.code === -1) {
                  this.tramitadorObservado =
                    "Los datos no son correctos. Por favor, verifique los datos introducidos.";
                  this.$message.warning(
                    "El apoderado no puede ser registrado por:" +
                      response.message
                  );
                } else {
                  if (response.code === 2) {
                    this.tramitadorObservado =
                      "Los datos introducidos no existen.";
                    this.$message.warning(
                      "El apoderado no puede ser registrado por:" +
                        response.message
                    );
                  } else {
                    this.tramitadorObservado =
                      "Tiene observaciones en el SEGIP, debe solucionarlas para poder continuar";
                    this.$message.warning(
                      "El apoderado no puede ser registrado por:" +
                        response.message
                    );
                  }
                }
              } else {
                if (response.code === 1) {
                  this.tramitadorObservado = false;
                  let data = Object.assign({}, this.$store.state.solicitud, {
                    tramitador_tipoDoc: this.form.tramitador_tipoDoc,
                    tramitador_nroDoc: doc.nroDocumento,
                    tramitador_nombres: this.form.tramitador_nombres,
                    tramitador_primerAp: this.form.tramitador_primerAp,
                    tramitador_segundoAp: this.form.tramitador_segundoAp,
                    tramitador_nacionalidad: this.form.tramitador_nacionalidad
                  });
                  this.$store.commit("setSolicitud", data);
                }
              }
            }
          });
      }
    },

    async solicitar () {
      if (this.btnSolicitar) return false;

      if (this.docsSolicitud.length === 0) {
        this.$message.warning(
          "Debe agregar por lo menos un documento para ser legalizado/certificado"
        );
        return false;
      }

      if (this.tramitadorObservado) {
        this.$message.error(
          "El tramitador no pudo ser validado, debe subsanar las observaciones con SEGIP"
        );
        return false;
      }

      if (
        this.form.tipoDoc === this.form.tramitador_tipoDoc &&
        this.form.nroDoc === this.form.tramitador_nroDoc
      ) {
        this.$message.error("El tramitador no puede ser igual al titular.");
        return false;
      }

      if (await this.$validator.validateAll()) {
        if (this.form.titular === "TRAMITADOR" && !this.validado) {
          this.$message.warning(
            "Debe validar los datos personales del tramitador"
          );
          return false;
        }

        this.$modal.confirm(this.$t("fields.confirmacion_solicitud"), () => {
          this.$loading.show("Procesando....");
          this.btnSolicitar = true;
          let data = Object.assign({}, this.$store.state.solicitud);
          data.tipoSolicitante = this.form.titular;
          data.fecNacimiento = this.$util.stringToDate(
            this.form.fecha_nacimiento
          );
          // data.fecNacimiento = this.form.fecha_nacimiento;
          data.regional = this.form.regional;
          delete data.mensaje;
          let docs = [];
          this.docsSolicitud.map(item => {
            docs.push({
              id: item.id,
              digital: item.tipo === "DIGITAL",
              motivo: item.otroMotivo
                ? item.motivo + "-" + item.otroMotivo
                : item.motivo,
              tipo_solicitud: this.getValueTipo(item.tipoSolicitud),
              para_apostillar: item.para_apostillar,
              gestion: item.gestion
            });
          });

          data.documentos = docs;

          if (
            this.form.titular === "TRAMITADOR" &&
            typeof this.tramitadorObservado === "string" &&
            !this.$filter.empty(this.tramitadorObservado)
          ) {
            data.tramitador_tipoDoc = this.form.tramitador_tipoDoc;
            data.tramitador_nroDoc = this.form.tramitador_nroDoc;
            data.tramitador_nombres = this.form.tramitador_nombres;
            data.tramitador_primerAp = this.form.tramitador_primerAp;
            data.tramitador_segundoAp = this.form.tramitador_segundoAp;
            data.tramitador_nacionalidad = this.form.tramitador_nacionalidad;
            data.tramitador_observacion = this.tramitadorObservado;
          }

          (async () => {
            let tramiteNuevo = null;

            await this.$service.post("registrar", data).then(response => {
              this.btnSolicitar = false;
              if (response) {
                this.codigo = response.cod_seguimiento;
              } else {
                this.codigo = null;
              }
            });

            if (this.codigo === null) {
              this.$loading.hide();
              this.$message.warning(
                "Hubo un problema de conexión, por favor inténtelo otra vez."
              );
              return false;
            }

            await delay(1500);

            await this.$service.get(`tramite/${this.codigo}`).then(response => {
              if (response) tramiteNuevo = response;
            });

            if (this.tramiteNuevo === null) {
              this.$loading.hide();
              this.$message.warning(
                "Hubo un problema de conexión, por favor inténtelo otra vez."
              );
              return false;
            }

            this.arrayTerceros = this.tieneTerceros(tramiteNuevo.documentos);

            if (this.arrayTerceros.length > 0) {
              this.step = 2;
            } else {
              await this.$service
                .post(`solicitud/${this.codigo}`, { presencia: false })
                .then(response => {
                  if (response) {
                    this.step = 3;
                    this.cleanForm();
                  } else {
                    this.$loading.hide();
                    this.$message.error(
                      "Ha ocurrido un error, vuelva a intentarlo"
                    );
                  }
                })
                .catch(error => {
                  this.$loading.hide();
                  this.$message.error(new Error(error));
                });
            }
            this.$loading.hide();
          })();
        });
      }
    },

    continuar () {
      this.$loading.show("Procesando....");
      this.$service.get(`tramite/${this.codigo}`).then(response => {
        if (response) {
          const tramiteNuevo = response;
          const arrayConAdjuntos = this.tieneTerceros(tramiteNuevo.documentos);
          if (arrayConAdjuntos.length > 0) {
            let obligatorios = [];
            arrayConAdjuntos.forEach(element => {
              if (element.id_archivo === 1) {
                obligatorios.push(element);
              }
            });
            if (obligatorios.length > 0) {
              this.$loading.hide();
              this.$message.error(
                "Por favor adjunte todos los archivos listados para poder finalizar su solicitud"
              );
            } else {
              this.$service
                .post(`solicitud/${this.codigo}`, { presencia: true })
                .then(response => {
                  if (response) {
                    if (response.code === -1) {
                      this.medio_notificacion = true;
                    }
                    this.step = 3;
                    this.cleanForm();
                    this.$loading.hide();
                  } else {
                    this.$loading.hide();
                    this.$message.error(
                      "Ha ocurrido un error, vuelva a intentarlo"
                    );
                  }
                })
                .catch(error => {
                  this.$loading.hide();
                  this.$message.error(new Error(error));
                });
            }
          } else {
            this.$service
              .post(`solicitud/${this.codigo}`, { presencia: false })
              .then(response => {
                if (response) {
                  this.step = 3;
                  this.cleanForm();
                  this.$loading.hide();
                } else {
                  this.$loading.hide();
                  this.$message.error(
                    "Ha ocurrido un error, vuelva a intentarlo"
                  );
                }
              })
              .catch(error => {
                this.$loading.hide();
                this.$message.error(new Error(error));
              });
          }
        } else {
          this.$loading.hide();
          this.$message.warning(
            "Hubo un problema de conexión, por favor inténtelo otra vez."
          );
        }
      });
    },

    cleanForm () {
      this.observado = false;
      this.form = {
        tipoDoc: "CI",
        nroDoc: "",
        nombres: "",
        primerAp: "",
        segundoAp: "",
        telefono: "",
        email: "",
        nacionalidad: "",
        id_documento: "",
        tipo: null,
        regional: null,
        tramitador_tipoDoc: "CI",
        tramitador_nroDoc: "",
        tramitador_nombres: "",
        tramitador_primerAp: "",
        tramitador_segundoAp: "",
        tramitador_nacionalidad: "BOLIVIANA",
        titular: "TITULAR",
        validado: false
      };
      this.$store.commit("setSolicitud", {});
      this.dateShow = false;
      this.$nextTick(() => {
        this.dateShow = true;
      });
    },

    cleanFormTitular () {
      this.observado = false;
      this.form.validado = false;
      this.$store.commit("setValid", false);
    },

    tieneTerceros (documentos) {
      let terceros = [];
      documentos.forEach(element => {
        if (
          element["documento.clasificacion"] === "EMITIDO_TERCEROS" ||
          (element["documento.adjunto_obligatorio"] === true &&
            element.gestion <= element["documento.gestion_fin"])
        ) {
          terceros.push(element);
        }
      });
      return terceros;
    },

    cambiar () {
      this.validado = false;
      this.tramitadorObservado = false;
    },

    cleanFormTramitador () {
      this.tramitadorObservado = false;
      this.validado = false;
      this.form = {
        tramitador_tipoDoc: "CI",
        tramitador_nroDoc: "",
        tramitador_nombres: "",
        tramitador_primerAp: "",
        tramitador_segundoAp: "",
        tramitador_nacionalidad: "BOLIVIANA"
      };
      this.tramitadorDateShow = false;
      this.$nextTick(() => {
        this.tramitadorDateShow = true;
      });
    },

    add () {
      if (!this.$filter.empty(this.form.id_documento)) {
        const documentoAgrupable = this.form.id_documento && this.form.id_documento.agrupable === true;
        const noAgrupablesCount = this.docsSolicitud.filter(item => !item.agrupable).length;
        if (noAgrupablesCount < 5 || documentoAgrupable) {
          let idVal = 0;
          if (typeof this.form.id_documento === 'object') {
            idVal = this.form.id_documento.id;
          } else {
            idVal = this.form.id_documento;
          }
          let doc = this.docs.filter(
           // item => item.id === this.form.id_documento
           item => item.id === idVal
          );
          doc = Object.assign({}, doc[0]);
          doc.tipo = "DIGITAL";
          doc.para_apostillar = false;
          // doc.tipoSolicitud = 'LEGALIZACIÓN';
          doc.motivo = "";
          doc.clasificacion = this.clasificacion;
          if (this.clasificacion === "EMITIDO_MINEDU") {
            doc.tipoSolicitud = "LEGALIZACIÓN";
            doc.gestion = "";
          }
          if (this.clasificacion === "EMITIDO_TERCEROS") {
            doc.tipoSolicitud = "CERTIFICACIÓN";
          }
          this.docsSolicitud.push(doc);
          let cambio = this.clasificacion;
          this.clasificacion = "";
          this.$nextTick(() => {
            this.clasificacion = cambio;
          });
        } else {
          this.$message.warning(
            "Solo puede pedir un máximo de 5 documentos por solicitud."
          );
        }
      } else {
        this.$message.warning(
          "Debe seleccionar un documento para agregarlo a su solicitud."
        );
      }
    },

    remove (index) {
      this.docsSolicitud = this.docsSolicitud.filter((item, i) => i !== index);
      this.digital = this.digital.filter((item, i) => i !== index);
    },

    prev (step = 0) {
      this.observado = false;
      this.form.titular = "TITULAR";
      this.step = step;
    },

    finish () {
      this.$router.push("/home");
    },

    cancel () {
      this.$modal.confirm(
        "¿Está seguro que quiere cancelar su solicitud de legalización?",
        () => {
          this.$router.push("/home");
        }
      );
    },

    getPrecio (id) {
      let doc = this.docs.filter(item => item.id === id);
      return doc[0] ? doc[0].precio || 0 : 0;
    },

    getClasificacion (id) {
      let doc = this.docs.filter(item => item.id === id);
      return doc[0] ? doc[0].clasificacion : "";
    },

    getCostoLegalizacion () {
      this.$service.get("costo").then(response => {
        if (response) {
          this.costoLegalizacion = parseFloat(response.valor);
        }
      });
    },

    getNroDocumento (nroDoc) {
      let nroDocumento = nroDoc.split("-");
      let complemento;
      if (nroDocumento.length > 1) {
        complemento = nroDocumento[1];
        nroDocumento = nroDocumento[0];
      } else {
        nroDocumento = nroDoc;
      }
      return {
        nroDocumento,
        complemento
      };
    },

    setTitular () {
      this.form.nombreFactura = `${this.form.primerAp} ${this.form.segundoAp} ${this.form.nombres}`;
      this.form.tipoFactura = this.form.tipoDoc;
      this.form.docFactura = this.form.nroDoc;
    },

    getValueTipo (texto) {
      let valor = "LEGALIZACION";
      if (texto === "LEGALIZACIÓN") {
        valor = "LEGALIZACION";
      } else {
        valor = "CERTIFICACION";
      }
      return valor;
    },

    generaGestiones (primeraGestion) {
      const fechaActual = new Date();
      let gestionActual = fechaActual.getUTCFullYear();
      let gestion = primeraGestion;
      while (gestion <= gestionActual) {
        this.gestiones.push(gestion);
        gestion = gestion + 1;
      }
    }
  },
  computed: {
    totalLegalizacion () {
      let total = 0;
      this.docsSolicitud.map(documento => {
        total += documento.precio;
      });
      return total;
    },

    verificarImpreso () {
      for (let i in this.docsSolicitud) {
        if (this.docsSolicitud[i].tipo === "IMPRESO") {
          return true;
        }
      }
      return false;
    }
  },
  components: {
    Stepper,
    DateSelect,
    Location,
    AdjuntaArchivo
  },
  watch: {
    "form.telefono": function (val) {
      // this.error.contacto = this.$filter.empty(this.form.telefono) && this.$filter.empty(this.form.email);
    },
    "form.email": function (val) {
      // this.error.contacto = this.$filter.empty(this.form.telefono) && this.$filter.empty(this.form.email);
    },
    // "form.id_documento": function (val) {
    //  if (!this.$filter.empty(val)) {
    //    this.precio = this.getPrecio(val) + " Bs.";
    //    this.clasificacion = this.getClasificacion(val);
    //  } else {
    //    this.precio = "";
    //    this.clasificacion = "";
    //  }
    // },
    "form.id_documento": function (val) {
      let idVal = 0;
      if (typeof val === 'object') {
        idVal = val.id;
      } else {
        idVal = val;
      }
      if (!this.$filter.empty(idVal)) {
        this.precio = this.getPrecio(idVal) + " Bs.";
        this.clasificacion = this.getClasificacion(idVal);
      } else {
        this.precio = "";
        this.clasificacion = "";
      }
    },
    "$store.state.lang": function () {
      this.steps = [
        { label: this.$t("fields.info_sol") },
        { label: this.$t("fields.info_doc") },
        { label: this.$t("fields.info_doc_adjuntar") },
        { label: this.$t("fields.info_finalizado") }
      ];
    },
    titular: function (val) {
      if (val === "SI") {
        this.setTitular();
      } else {
        this.form.nombreFactura = "";
        this.form.tipoFactura = "";
        this.form.docFactura = "";
      }
    },
    "form.titular": function (val) {
      this.form.tramitador_tipoDoc = "CI";
      this.form.tramitador_nroDoc = "";
      this.form.tramitador_nombres = "";
      this.form.tramitador_primerAp = "";
      this.form.tramitador_segundoAp = "";
      this.form.tramitador_nacionalidad = "BOLIVIANA";
      if (val === "TITULAR") {
        this.$nextTick(() => {
          this.tramitadorObservado = false;
          this.form.titular = "TITULAR";
          this.validado = false;
        });
      }
      if (val === "TRAMITADOR") {
        this.$nextTick(() => {
          this.tramitadorObservado = false;
          this.form.titular = "TRAMITADOR";
          this.validado = false;
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import "pages.scss";

.title-titular {
  margin: 30px 0 20px 0;

  span {
    margin-right: 20px;
  }

  .md-radio {
    margin: 0;
  }
}

.btn-search {
  margin-top: 10px;
}

.btn-margin {
  margin-top: 50px;
}

.md-radio-container {
  display: inline-block;
}

.grid {
  &.add-document {
    grid-template-columns: 8fr 1fr 1fr;
  }
}
.form-group-radios {
  margin: 15px 0 25px;
  label {
    display: inline-block;
    margin-left: 15px;
  }
}

.pago-total {
  max-width: 500px;
  margin: 0 auto 20px;
}
.campos-extra {
  margin-top: 10px;
}
.md-radio-inline {
  margin-left: 3.4rem;
}
@media (max-width: 768px) {
  .documentos .documento .opciones {
    position: static;
    margin-top: 10px;
    text-align: center;
  }

  .title-titular {
    .md-radio-inline {
      margin-bottom: 10px;
    }
  }
}

/* Tooltip container */
.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
}

/* Tooltip text */
.tooltip .tooltiptext {
  visibility: hidden;
  width: 300px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 5px 5px 5px;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -80px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
/* Settings to align the apoderado box  */
.cuadro-texto-apoderado {
  margin-left: 2.3rem;
  display: block;
  text-align: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Solicitud.vue